/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Lot_Status_ShippedInputs */

const en_so_lot_status_shipped = /** @type {(inputs: So_Lot_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped`)
};

/**
* | output |
* | --- |
* | "Shipped" |
*
* @param {So_Lot_Status_ShippedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_lot_status_shipped = /** @type {((inputs?: So_Lot_Status_ShippedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Lot_Status_ShippedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_lot_status_shipped(inputs)
});